import { useState, useEffect } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import ScrollToTop from "react-scroll-to-top";

import "../../styles/header.css";
import { headerData } from "../../_helpers/header-data";
import { faFacebook, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { Loader } from "../utilities/loader";
import { AppAlert } from "../utilities/alert";

export const Header = ({pageTitle}) => {

    const navigateTo = useNavigate();
    const { isAuthenticated, isLoading, adminLogout, token } = useAuthentication();

    const [showNav, setShowNav] = useState(false);
    const [isAlert, setIsAlert] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = pageTitle
    }, [])

    return (
        <header>
            {showNav &&
                <div
                    className={classNames("dark-cover")}
                    onClick={() => setShowNav(false)}
                />
            }
            <ScrollToTop smooth />
            { isLoading && <Loader /> }
            {isAlert && (
                <AppAlert
                    caption={isAlert.caption}
                    message={isAlert.message}
                    accept={isAlert.accept}
                    reject={isAlert.reject}
                    onAccept={isAlert.onAccept}
                    onReject={isAlert.onReject}
                    onClose={isAlert.onClose}
                />
            )}
            <img className="app-logo" alt="app-logo" src="/images/gen-logo.jpg" />
            <div className={classNames("app-nav", { "shown": showNav })}>
                <div className={classNames("cls-box", 'flx-e', 'flx-r')}>
                    <button
                        className={classNames('tr-btn', 'btn')}
                        onClick={() => setShowNav((s) => !s)}
                        style={{ fontSize: 32 }}
                    >
                        { showNav && <FontAwesomeIcon icon={faClose} /> }
                    </button>
                </div>
                <div
                    className={classNames('flx-r', 'c-j', 'fol-box')}
                >
                    <button
                        className={classNames('btn', 'tr-btn', 'fol')}
                        onClick={() => window.location.href = "https://facebook.com/groups/374534424557231/"}
                    >
                        <FontAwesomeIcon icon={faFacebook} className="fol-icon" />
                    </button>
                    <button
                        className={classNames('btn', 'tr-btn', 'fol')}
                        onClick={() => window.location.href = 'https://www.tiktok.com/@mbecudaworld'}
                    >
                        <FontAwesomeIcon icon={faTiktok} className="fol-icon" />
                    </button>
                    <button
                        className={classNames('btn', 'tr-btn', 'fol')}
                        onClick={() => window.location.href = "https://www.instagram.com/mbecudaworld/"}
                    >
                        <FontAwesomeIcon icon={faInstagram} className="fol-icon" />
                    </button>
                    <button
                        className={classNames('btn', 'tr-btn', 'fol')}
                        onClick={() => window.location.href = 'https://www.youtube.com/@mbecuda'}
                    >
                        <FontAwesomeIcon icon={faYoutube} className="fol-icon" />
                    </button>
                </div>
                {headerData.map((data, k) => (
                    <button
                        className={classNames("hr-4", "btn", "tr-btn")}
                        key={k}
                        onClick={() => navigateTo(data.uri)}
                    >
                        <span className="nav-btn-cap">{data.caption}</span>
                    </button>
                ))
                }
                {isAuthenticated !== true ? (
                    <button
                        className={classNames("hr-4", "btn", "tr-btn")}
                        onClick={() => navigateTo('/login')}
                    >
                        <span className="nav-btn-cap">{'Login'}</span>
                    </button>
                ) : (
                    <button
                        className={classNames("hr-4", "btn", "tr-btn")}
                        onClick={() => {
                            setIsAlert({
                                caption: "Logout",
                                message: "Do you wish to logout?",
                                accept: "Yes",
                                reject: "Cancel",
                                onAccept: async () => {
                                    await adminLogout(token);
                                    setIsAlert();
                                },
                                onReject: () => setIsAlert(),
                                onClose: () => setIsAlert(),
                            })
                        }}
                    >
                        <span className="nav-btn-cap">{'Logout'}</span>
                    </button>
                )

                }

            </div>
            <div className={"mobi-nav-ctrl"}>
                <button className={classNames('tr-btn', 'btn')} onClick={() => setShowNav((s) => !s)}>
                    {!showNav && <FontAwesomeIcon icon={showNav ? faClose : faBars} />}
                </button>
            </div>
        </header>
    )
}